import { render } from "./ExcelStaffTable.vue?vue&type=template&id=36c085b6&scoped=true"
import script from "./ExcelStaffTable.vue?vue&type=script&lang=js"
export * from "./ExcelStaffTable.vue?vue&type=script&lang=js"

import "./ExcelStaffTable.vue?vue&type=style&index=0&id=36c085b6&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c085b6"]])

export default __exports__